/**
 * Copyright © 2019 Apple Inc. All rights reserved.
 */

let IneligibilityReason;
(function (IneligibilityReason) {
  IneligibilityReason["CanBuyVppLicenses"] = "UnsupportedAccountTypeForWeb_CanBuyVppLicenses";
  IneligibilityReason["CanManageVppLicenses"] = "UnsupportedAccountTypeForWeb_CanManageVppLicenses";
  IneligibilityReason["CanShopInVolumeEducationStore"] = "UnsupportedAccountTypeForWeb_CanShopInVolumeEducationStore";
  IneligibilityReason["CanShopInVolumeEnterpriseStore"] = "UnsupportedAccountTypeForWeb_CanShopInVolumeEnterpriseStore";
  IneligibilityReason["ConversionRequired"] = "UnsupportedAccountTypeForWeb_ConversionRequired";
  IneligibilityReason["IsManagedAppleId"] = "UnsupportedAccountTypeForWeb_IsManagedAppleId";
  IneligibilityReason["IsSpecialEduAccount"] = "UnsupportedAccountTypeForWeb_IsSpecialEduAccount";
  IneligibilityReason["SecurityUpgradeRequired"] = "UnsupportedAccountTypeForWeb_SecurityUpgradeRequired";
  IneligibilityReason["LiteAccount"] = "UnsupportedAccountTypeForWeb_LiteAccount";
  IneligibilityReason["NoAccountFound"] = "NoAccountFound";
  IneligibilityReason["IneligibleStorefront"] = "IneligibleStoreFront";
  IneligibilityReason["Unauthorized"] = "Unauthorized";
  IneligibilityReason["IsDormant"] = "UnsupportedAccountTypeForWeb_IsDormant";
})(IneligibilityReason || (IneligibilityReason = {})); // HTTP 403
let AuthType; // Used for integration w/ CWA on appleid.apple.com
(function (AuthType) {
  AuthType["DefaultWeb"] = "web";
  AuthType["WebService"] = "ws";
  AuthType["GrandSlam"] = "gs";
})(AuthType || (AuthType = {}));
let AuthDisplayType;
(function (AuthDisplayType) {
  AuthDisplayType["Inline"] = "inline";
  AuthDisplayType["Modal"] = "modal";
})(AuthDisplayType || (AuthDisplayType = {}));

let BagKey$1;
(function (BagKey) {
  BagKey["AccountCardType"] = "accountCardType";
  BagKey["AccountCreateWeb"] = "account-create-web";
  BagKey["AccountRecoverySubscription"] = "account-recovery-candidates";
  BagKey["AccountSettingsAppleIdSiteUrl"] = "appleIdSiteUrl";
  BagKey["AccountSettingsChangeStorefrontUrl"] = "changeStoreFrontUrl";
  BagKey["AccountSettingsGraphqlUrl"] = "accountSummaryGraphQL";
  BagKey["AccountSummaryUrl"] = "modifyAccount";
  BagKey["AcknowledgeMessage"] = "acknowledge-message";
  BagKey["AddFundsInfo"] = "addFundsInfoSrv";
  BagKey["AddFundsOther"] = "addFundsOtherSrv";
  BagKey["AddFundsSuccess"] = "addFundsSuccessSrv";
  BagKey["AddFundsUrl"] = "AddFundsUrl";
  BagKey["ApplePayClassicSettingsUrl"] = "apple-pay-classic-settings-url";
  BagKey["ApplePayEnroll"] = "applePayEnroll";
  BagKey["ApplePaySession"] = "applePayPaymentSession";
  BagKey["AssignSubscriptionBeneficiary"] = "assignSubscriptionBeneficiary";
  BagKey["AurumEditAddress"] = "aurumEditAddress";
  BagKey["AutoReloadCancel"] = "addFundsCancelAutoReloadSrv";
  BagKey["AutoReloadSuccess"] = "addFundsAutoReloadInfoSrv";
  BagKey["BankTokenUrl"] = "bankTokenUrl";
  BagKey["BuySubscription"] = "buySubscription";
  BagKey["BuySubscriptionExit"] = "buySubscriptionExit";
  BagKey["CancelPreorders"] = "cancelPreorderItemsSrv";
  BagKey["CancelSegmentVerificationState"] = "cancelSegmentVerificationState";
  BagKey["CheckForCarrierOffers"] = "checkChannelOffers";
  BagKey["CommerceAppFallbackUrl"] = "commerceAppFallbackUrl";
  BagKey["CommerceBaseUrl"] = "commerceAppBaseUrl";
  BagKey["CommerceUiUrls"] = "commerce-ui-urls";
  BagKey["ContentBonusOfferRedemptionEnabled"] = "contentBonusOfferRedemptionEnabled";
  BagKey["CreateSegmentVerificationSession"] = "createSegmentVerificationSession";
  BagKey["DeauthAllMachines"] = "deauthAllMachines";
  BagKey["DeleteSegmentVerificationSession"] = "deleteSegmentVerificationSession";
  BagKey["DeviceProfileTrustedDomains"] = "psd2-device-profile-trusted-domains";
  BagKey["EditAccountFieldsSrvV2"] = "editAccountFieldsSrvV2";
  BagKey["EmailTermsSrv"] = "emailTermsSrv";
  BagKey["ExternalVerificationStatus"] = "getExternalVerificationStatus";
  BagKey["FinanceAppBaseUrl"] = "financeApp.baseUrl";
  BagKey["FinanceManagePayments"] = "paymentInformationUrl";
  BagKey["GenerateEmailConfirmationCode"] = "generateEmailConfirmationCode";
  BagKey["GetAccountPreferences"] = "getSubscriptionAccountPreferences";
  BagKey["GetCardType"] = "getCardType";
  BagKey["GetCarmConfigure"] = "getCarmConfigure";
  BagKey["GetSegmentVerificationSession"] = "getSegmentVerificationSession";
  BagKey["GetSegmentVerificationStateAuthdbCountryList"] = "getSegmentVerificationStateAuthdbCountryList";
  BagKey["GetSegmentVerificationStateAuthdbForm"] = "getSegmentVerificationStateAuthdbFormMetadata";
  BagKey["GetStudentVerificationStateAuthdbSchoolList"] = "getStudentVerificationStateAuthdbSchoolList";
  BagKey["GetSubscriptionOffersSrv"] = "getSubscriptionOffersSrv";
  BagKey["GetSubscriptionsInfoSrv"] = "getSubscriptionInfoSrv";
  BagKey["GetSubscriptionsSrv"] = "getSubscriptionsSrv";
  BagKey["GetTermsByCountryAndTypeSrv"] = "getTermsByCountryAndTypeSrv";
  BagKey["GetVerificationSessionHelpUrl"] = "getVerificationSessionHelpUrl";
  BagKey["GetVerificationUrl"] = "getVerificationUrl";
  BagKey["IdVerificationFieldsSrv"] = "idVerificationFieldsSrv";
  BagKey["InitiateChallenge"] = "initiateChallenge";
  BagKey["InitiateIdVerification"] = "initiateIdVerification";
  BagKey["InvoiceReductionSrv"] = "invoiceReductionSrv";
  BagKey["IsBundleEnabled"] = "isBundleEnabled";
  BagKey["IsInvoiceReductionEnabled"] = "isInvoiceReductionEnabled";
  BagKey["IsKoreaAgeVerificationEnabled"] = "isKoreaAgeVerificationEnabled";
  BagKey["IsManageIcloudStorageEnabled"] = "isManageIcloudStorageEnabled";
  BagKey["IsManagePaymentsEnabled"] = "isManagePaymentsEnabled";
  BagKey["IsPsd2LoggingEnabled"] = "isPsd2LoggingEnabled";
  BagKey["Language"] = "language";
  BagKey["LanguageTag"] = "language-tag";
  BagKey["LegacyEditBillingInfo"] = "legacyEditBillingInfoSrvV2";
  BagKey["LegacyEditBillingInfoSrvV2"] = "legacyEditBillingInfoSrvV2";
  BagKey["LoadCreateAccountFieldsSrv"] = "createAccountFieldsSrv";
  BagKey["ManageDevicesSlotInfo"] = "manageDevicesSlotInfo";
  BagKey["ManagePaymentsUrl"] = "managePaymentsUrl";
  BagKey["Metrics"] = "metrics";
  BagKey["ModifyAccountWk1"] = "modifyAccountWk1";
  BagKey["PaymentAdd"] = "addBillingInfoSrv";
  BagKey["PaymentAddV2"] = "addBillingInfoSrvV2";
  BagKey["PaymentEdit"] = "editBillingInfoSrv";
  BagKey["PaymentEditV2"] = "editBillingInfoSrvV2";
  BagKey["PaymentInfos"] = "paymentInfos";
  BagKey["PaymentInfosAdd"] = "paymentInfosAdd";
  BagKey["PaymentInfosEdit"] = "paymentInfosEdit";
  BagKey["PaymentInfosRemove"] = "paymentInfosRemove";
  BagKey["PaymentInfosRemoveApplePayClassic"] = "paymentInfosRemoveApplePayClassic";
  BagKey["PaymentLegacyEditV2"] = "legacyEditBillingInfoSrvV2";
  BagKey["PaymentOptions"] = "paymentOptionsSrv";
  BagKey["PaymentsAndShippingUrl"] = "paymentsAndShippingUrl";
  BagKey["PostSegmentVerificationStateAuthdbForm"] = "postSegmentVerificationStateAuthdbForm";
  BagKey["PostSegmentVerificationStateDocumentReviewForm"] = "postSegmentVerificationStateDocumentReviewForm";
  BagKey["PostSegmentVerificationStateEmailCode"] = "postSegmentVerificationStateEmailCode";
  BagKey["PostSegmentVerificationStateEmailForm"] = "postSegmentVerificationStateEmailForm";
  BagKey["PostSegmentVerificationStateSingleSignOnForm"] = "postSegmentVerificationStateSingleSignOnForm";
  BagKey["PreferredRenewalOption"] = "preferredRenewalOption";
  BagKey["Preorders"] = "preorderItemsSrv";
  BagKey["PreordersUrl"] = "preordersUrl";
  BagKey["PrivacyConsentConsent"] = "pipl-urls/apple/consent";
  BagKey["PrivacyConsentDissent"] = "pipl-urls/apple/dissent";
  BagKey["PrivacyConsentQueryConsent"] = "pipl-urls/apple/queryConsent";
  BagKey["ProductInfo"] = "productInfo";
  BagKey["Psd2LoggingUrl"] = "psd2LoggingUrl";
  BagKey["PurchaseHistoryUrl"] = "purchaseHistoryUrl";
  BagKey["PvkAddPmofUrl"] = "pvkAddPmofUrl";
  BagKey["PvkBiometricsOnlyAuth"] = "pvkBiometricsOnlyAuth";
  BagKey["PvkEmailGenerateCodeUrl"] = "pvkEmailGenerateCodeUrl";
  BagKey["PvkEmailValidateCodeUrl"] = "pvkEmailValidateCodeUrl";
  BagKey["PvkEmailWaterfallUrl"] = "pvkEmailWaterfallUrl";
  BagKey["RedeemCodeSrv"] = "redeemCodeSrv";
  BagKey["RedeemDeclineBonus"] = "declineBonus";
  BagKey["RedeemInfo"] = "redeemInfo";
  BagKey["RedeemLandingUrl"] = "redeemCodeLanding";
  BagKey["RedeemMarketingUrl"] = "redeemMarketingUrl";
  BagKey["RedeemValidateIdUrl"] = "redeemValidateIdUrl";
  BagKey["Redirect3dSecureUrl"] = "redirect3DSecureUrl";
  BagKey["RefundRequest"] = "inAppRefund";
  BagKey["RefundTransactionDetails"] = "inAppRefundReasons";
  BagKey["ReinitiateIdVerification"] = "reinitiateIdVerification";
  BagKey["RemoveDeviceSlot"] = "removeDeviceSlot";
  BagKey["RepairSubscriptionUsingExternalVerification"] = "repair-subscription-using-external-verification";
  BagKey["ResendCarmOtp"] = "resendCarmOtp";
  BagKey["ReverifySegmentStatus"] = "reverifySegmentStatus";
  BagKey["SandboxClearPurchaseHistory"] = "sandboxClearPurchaseHistory";
  BagKey["SandboxGetIntroOfferStatus"] = "sandboxIntroOfferStatus";
  BagKey["SandboxResetIntroOffer"] = "sandboxResetIntroOffer";
  BagKey["SandboxSubscriptionRenewalRate"] = "sandboxSubscriptionRenewalRate";
  BagKey["SendCarmOtp"] = "sendCarmOtp";
  BagKey["SendSegmentVerificationStateDocumentReviewLink"] = "sendSegmentVerificationStateDocumentReviewLink";
  BagKey["ShippingAddressDelete"] = "deleteShippingAddress";
  BagKey["ShippingAddressEdit"] = "editShippingAddressSrv";
  BagKey["SpeedybuyConfirmationDialog"] = "speedybuyConfirmationDialog";
  BagKey["StackableApplePayClassicSubscriptions"] = "apple-pay-classic-subscription-infos-url";
  BagKey["StackableDeletePayment"] = "deleteStackablePaymentSrv";
  BagKey["StackablePayments"] = "getStackablePaymentsSrv";
  BagKey["StackablePaymentsWithApplePay"] = "paymentInfoWithApplePay";
  BagKey["StackablePaymentsWithApplePayClassic"] = "apple-pay-classic-payment-infos-url";
  BagKey["StackableReorderPayments"] = "reorderStackablePaymentsSrv";
  BagKey["StartExternalVerification"] = "startExternalVerification";
  BagKey["SubscriptionDetailsV3"] = "getSubscriptionDetails";
  BagKey["SubscriptionImpactMessaging"] = "impactMessaging";
  BagKey["SubscriptionUnbundleOptionsV3"] = "getUnbundleOptions";
  BagKey["SubscriptionsListV3"] = "getSubscriptionList";
  BagKey["TermsCheck"] = "terms-check";
  BagKey["ToggleAccountFamilySharing"] = "toggle-account-family-sharing";
  BagKey["ToggleFamilySharing"] = "toggle-family-sharing";
  BagKey["UnbundleSubscriptionOptionsSrv"] = "unbundleSubscriptionOptionsSrv";
  BagKey["UnbundleSubscriptionSrv"] = "unbundleSubscriptionSrv";
  BagKey["UnlinkSegmentStatus"] = "unlinkSegmentStatus";
  BagKey["UpdateAutoRenewStateSrv"] = "updateAutoRenewStateSrv";
  BagKey["UpdateIcloudStorageSrv"] = "updateIcloudStorageSrv";
  BagKey["ValidateAccountForChangeCountrySrvV2"] = "validateAccountForChangeCountrySrvV2";
  BagKey["ValidateCarm"] = "validateCarm";
  BagKey["ValidateEmailConfirmationCode"] = "validateEmailConfirmationCode";
  BagKey["VerificationKitInit"] = "verification_kit_init";
  BagKey["VerificationUrl"] = "verificationUrl";
  BagKey["VerifyChallenge"] = "verifyChallenge";
  BagKey["VerifyIdVerification"] = "verifyIdVerification";
  BagKey["VerifyPayment"] = "verifyPayment";
})(BagKey$1 || (BagKey$1 = {}));

let LocalBagKey;
(function (LocalBagKey) {
  LocalBagKey["AcknowledgeMessageWeb"] = "acknowledgeMessage";
  LocalBagKey["Auth"] = "auth";
  LocalBagKey["Logout"] = "logout";
  LocalBagKey["LogoutAll"] = "logoutAll";
  LocalBagKey["AccountCreateOptions"] = "accountCreateOptions";
  LocalBagKey["AccountConversionInit"] = "accountConversionInit";
  LocalBagKey["AccountConversionSetSignedup"] = "accountConversionSetSignedup";
  LocalBagKey["AccountPodSrv"] = "accountPodSrv";
  LocalBagKey["AccountSettingsSrv"] = "accountSettingsSrv";
  LocalBagKey["AcknowledgePrivacy"] = "acknowledgePrivacy";
  LocalBagKey["AndroidMusicRedeemReferrerUrl"] = "androidMusicRedeemReferrerUrl";
  LocalBagKey["AosOrderDetailsUrl"] = "aosOrderDetailsUrl";
  LocalBagKey["AppAccessRequest"] = "appAccessRequest";
  LocalBagKey["AuthGrandSlam"] = "authGrandSlam";
  LocalBagKey["AuthWebService"] = "authWebService";
  LocalBagKey["AuthWebServiceRefresh"] = "authWebServiceRefresh";
  LocalBagKey["AmpTermsGetUrl"] = "ampTermsGetUrl";
  LocalBagKey["AmpTermsVerifyUrl"] = "ampTermsVerifyUrl";
  LocalBagKey["BuySubscription"] = "buySubscription";
  LocalBagKey["CarrierLinkSrv"] = "carrierLinkSrv";
  LocalBagKey["CreateAccountFieldsSrv"] = "createAccountFieldsSrv";
  LocalBagKey["ChannelSendSms"] = "sendSMSCode";
  LocalBagKey["ChannelVerifySms"] = "verifySMSCode";
  LocalBagKey["GetChannelSubscriptionOfferParameters"] = "getChannelSubscriptionOfferParameters";
  LocalBagKey["CreateAccountSrv"] = "createAccountSrv";
  LocalBagKey["DeviceLinkValidate"] = "deviceLinkValidate";
  LocalBagKey["EditBillingInfoSrv"] = "editBillingInfoSrv";
  LocalBagKey["GenerateAndSendSecCodeSrv"] = "generateAndSendSecCodeSrv";
  LocalBagKey["GenerateEmailConfirmationCodeSrv"] = "generateEmailConfirmationCodeSrv";
  LocalBagKey["GetPayPalUrl"] = "getPayPalUrl";
  LocalBagKey["GetTermsByCountryAndTypeSrv"] = "getTermsByCountryAndTypeSrv";
  LocalBagKey["IdVerificationFieldsSrv"] = "idVerificationFieldsSrv";
  LocalBagKey["InitiateIdVerification"] = "initiateIdVerification";
  LocalBagKey["linkChannelSubscription"] = "linkChannelSubscription";
  LocalBagKey["NuDataSyncResponseSrv"] = "nuDataSyncResponseSrv";
  LocalBagKey["ParentalControlsDisable"] = "parentalControlsDisable";
  LocalBagKey["ParentalControlsEdit"] = "parentalControlsEdit";
  LocalBagKey["ParentalControlsPinEdit"] = "parentalControlsPinEdit";
  LocalBagKey["ParentalControlsPinVerify"] = "parentalControlsPinVerify";
  LocalBagKey["ParentalControlsVideo"] = "parentalControlsVideo";
  LocalBagKey["ParentalControlsMusic"] = "parentalControlsMusic";
  LocalBagKey["ParentalControlsRecoveryEmailEdit"] = "parentalControlsRecoveryEmailEdit";
  LocalBagKey["ParentalControlsRecoveryEmailSend"] = "parentalControlsRecoveryEmailSend";
  LocalBagKey["ParentalControlsSetup"] = "parentalControlsSetup";
  LocalBagKey["PaymentOptionsSrv"] = "paymentOptionsSrv";
  LocalBagKey["RedeemCodeInfo"] = "redeemCodeInfo";
  LocalBagKey["RedeemSubscription"] = "redeemSubscription";
  LocalBagKey["ReInitiateIdVerification"] = "reInitiateIdVerification";
  LocalBagKey["SendCarmOtp"] = "sendCarmOtp";
  LocalBagKey["CarrierBillingOtpInitiate"] = "dcbManualOtpInitiate";
  LocalBagKey["CarrierBillingOtpReinitiate"] = "dcbManualOtpReinitiate";
  LocalBagKey["CarrierBillingValidateOtp"] = "dcbManualOtpValidate";
  LocalBagKey["CarrierChannelLinkSrv"] = "carrierChannelLinkSrv";
  LocalBagKey["CarrierChannelSendSmsSrv"] = "carrierChannelSendSmsSrv";
  LocalBagKey["CarrierChannelVerifySmsSrv"] = "carrierChannelVerifySmsSrv";
  LocalBagKey["SubscriptionConfirmation"] = "subscriptionConfirmation";
  LocalBagKey["SubscriptionOffers"] = "subscriptionOffers";
  LocalBagKey["SubscriptionStatus"] = "subscriptionStatus";
  LocalBagKey["SubscriptionsSrv"] = "subscriptionsSrv";
  LocalBagKey["SubscriptionNotify"] = "subscriptionNotify";
  LocalBagKey["TermsAndConditions"] = "termsAndConditions";
  LocalBagKey["TermsCheckSrv"] = "termsCheckSrv";
  LocalBagKey["ThirdPartyLogin"] = "thirdPartyLogin";
  LocalBagKey["TvAgeVerifyPayment"] = "tvAgeVerifyPayment";
  LocalBagKey["ValidateAccountFieldsSrv"] = "validateAccountFieldsSrv";
  LocalBagKey["ValidateAccountNameSrv"] = "validateAccountNameSrv";
  LocalBagKey["InitializeSessionSrv"] = "initializeSessionSrv";
  LocalBagKey["ValidateCarm"] = "validateCarm";
  LocalBagKey["ValidateEmailConfirmationCodeSrv"] = "validateEmailConfirmationCodeSrv";
  LocalBagKey["ValidateSecCodeSrv"] = "validateSecCodeSrv";
  LocalBagKey["VerifyIdVerification"] = "verifyIdVerification";
  LocalBagKey["PaymentChallengeInitiate"] = "paymentChallengeInitiate";
  LocalBagKey["PaymentChallengeVerify"] = "paymentChallengeVerify";
  LocalBagKey["WatchListSettings"] = "watchListSettings";
  LocalBagKey["WebAccountInfo"] = "webAccountInfo";
  LocalBagKey["WebAccountInfoRefresh"] = "webAccountInfoRefresh";
  LocalBagKey["QrAuthValidate"] = "qrAuthValidate";
  LocalBagKey["QrAuthLink"] = "qrAuthLink";
  LocalBagKey["QrAuthRoute"] = "qrAuthRoute";
  LocalBagKey["RegisterDeviceFpdi"] = "registerDeviceFpdi";
  LocalBagKey["IdmsSignin"] = "idmsSignin";
  LocalBagKey["IdmsSigninUAT"] = "idmsSigninUAT";
  LocalBagKey["StoreFrontId"] = "storeFrontId";
  LocalBagKey["GetRestrictedCreateAccountOptions"] = "getRestrictedCreateAccountOptions";
  LocalBagKey["ValidateOauthLinkCode"] = "validateOauthLinkCode";
  LocalBagKey["QrAuthWeb"] = "qrAuthWeb";
  LocalBagKey["InitializeOauthLinkFlow"] = "initializeOauthLinkFlow";
  LocalBagKey["CancelBuy"] = "cancelBuy";
  LocalBagKey["MercuryBaseUrlTv"] = "mercuryBaseUrlTv";
  LocalBagKey["MercuryBaseUrlMusic"] = "mercuryBaseUrlMusic";
  LocalBagKey["InboxMessages"] = "inboxMessages";
  LocalBagKey["RemoteUnlink"] = "remoteUnlink";
})(LocalBagKey || (LocalBagKey = {}));
const BagKey = {
  ...LocalBagKey,
  ...BagKey$1
};

/*
 * returns true if the input url includes any query params passed in the second argument
 *
 * Todo: remove this once below radar is implemented
 * rdar://79707935 (Expose hasQueryParams method from affiliate-util module)
 */

/**
 * returns query string from the input dictionary
 *
 * usage:
 * getQueryParamsStringFromDictionary({ a: 1, b: 2 })
 * returns a=1&b=2
 */
const getQueryParamsStringFromDictionary = paramsDictionary => {
  const populatedParamsDictionary = Object.entries(paramsDictionary).filter(_ref => {
    let [, value] = _ref;
    return value !== null && value !== undefined && value !== '';
  }).reduce((filteredParams, _ref2) => {
    let [key, value] = _ref2;
    return {
      ...filteredParams,
      [key]: value
    };
  }, {});
  const searchParams = new URLSearchParams(populatedParamsDictionary);
  return searchParams.toString();
};

/**
 * returns hash of query params from input URL
 *
 * usage:
 * getQueryParamsObj('https://test.com?a=1&b=2')
 * returns { a: 1, b: 2 }
 */
const getQueryParamsObj = function (url) {
  let decode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const selectQueryParams = new RegExp('([^?=&]+)(=([^&]*))', 'g');
  const match = url.match(selectQueryParams);
  if (!match) {
    return {};
  }
  return match.reduce((result, keyValue) => {
    const values = keyValue.split('=');
    const key = values[0];
    const value = values[1];
    result[key] = decode ? decodeURIComponent(value) : value;
    return result;
  }, {});
};

const throttle = function (func, delay) {
  let isLeading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // isLeading === true means the function should be called
  // at the beginning of throttling; if `false` the function should be
  // called at the end of the throttle delay

  let isThrottling = false;
  let timeout;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (!isThrottling) {
      isThrottling = true;
      if (timeout) {
        clearTimeout(timeout);
      }
      if (isLeading) {
        func.call(null, ...args);
      }
      timeout = setTimeout(() => {
        isThrottling = false;
        if (!isLeading) {
          func.call(null, ...args);
        }
      }, delay);
    }
  };
};

let HostedAppSubdomain;
(function (HostedAppSubdomain) {
  HostedAppSubdomain["Apps"] = "apps";
  HostedAppSubdomain["Tv"] = "tv";
  HostedAppSubdomain["Music"] = "music";
  HostedAppSubdomain["PodcastsConnect"] = "podcastsconnect";
  HostedAppSubdomain["Podcasts"] = "podcasts";
  HostedAppSubdomain["Activate"] = "activate";
})(HostedAppSubdomain || (HostedAppSubdomain = {}));
let HostedAppEnvironment;
(function (HostedAppEnvironment) {
  HostedAppEnvironment["Prod"] = "";
  HostedAppEnvironment["Carry"] = "carry";
  HostedAppEnvironment["Beta"] = "beta";
  HostedAppEnvironment["Nightly"] = "nightly";
  HostedAppEnvironment["Itms5"] = "itms5";
  HostedAppEnvironment["Itms7"] = "itms7";
  HostedAppEnvironment["Itms8"] = "itms8";
  HostedAppEnvironment["Itms11"] = "itms11";
  HostedAppEnvironment["ContentPreview"] = "cp";
  HostedAppEnvironment["Pddev"] = "pddev";
  HostedAppEnvironment["Dev"] = "dev";
})(HostedAppEnvironment || (HostedAppEnvironment = {}));
const HostedAppConfig = {
  ['web-app']: {
    basePath: '/includes/commerce'
  },
  ['cwa-app']: {
    basePath: '/includes/cwa'
  }
};

const isInIframe = () => {
  // This strange-looking property access style is a workaround for Cypress'
  // behavior of rewriting _some_ code that references `window.parent`:
  const par = window.parent;
  return window !== par;
};
const isObject = item => {
  return !!item && typeof item === 'object' && !Array.isArray(item);
};

const getProductVersion = () => {
  /* istanbul ignore if */
  if (typeof document === 'undefined' || !document.querySelector) {
    return '';
  }
  const metaEl = document.querySelector('meta[name=version]');

  /* istanbul ignore next */
  return metaEl && metaEl.content || '';
};
let Theme;
(function (Theme) {
  Theme["Light"] = "light";
  Theme["Dark"] = "dark";
})(Theme || (Theme = {}));
const defaultConfig = {
  modalOptions: {
    containerSelector: 'body'
  },
  fetchOptions: {
    shouldEnableFetchProxy: false,
    proxyContainerSelector: 'body'
  },
  authOptions: {
    type: AuthType.DefaultWeb,
    displayType: AuthDisplayType.Inline,
    shouldDelegateAuthUI: false
  },
  // TODO: rdar://110081269 (CommerceKit: persist certain config options throughout hierarchy)
  shouldDetectUserActivity: false,
  userActivityOptions: {
    detectionIntervalInMs: 1000,
    eventsToDetect: ['scroll', 'keydown', 'pointerdown']
  },
  productVersion: getProductVersion(),
  hostedAppMetadata: {
    subdomain: HostedAppSubdomain.Apps,
    environment: HostedAppEnvironment.Prod
  },
  useRelativeIframeSrc: false,
  logLevel: 'warning'
};
let config = defaultConfig;
const deepCloneConfigItem = (item, deepCloneObjectFunc) => {
  if (isObject(item)) {
    return deepCloneObjectFunc(item);
  } else if (Array.isArray(item)) {
    return Array.from(item);
  }
  return item;
};
const deepCloneConfig = target => {
  const output = {};
  for (const key in target) {
    output[key] = deepCloneConfigItem(target[key], deepCloneConfig);
  }
  return output;
};

/** Note: Arrays are replaced, not merged. */
const mergeConfigs = (target, source) => {
  const output = deepCloneConfig(target);
  for (const key in source) {
    const sourceItem = source[key];
    const targetItem = target[key];

    // Merge objects from source into target
    if (key in target && isObject(sourceItem) && isObject(targetItem)) {
      output[key] = mergeConfigs(targetItem, sourceItem);

      // Add or override item from source to target
    } else {
      output[key] = deepCloneConfigItem(sourceItem, deepCloneConfig);
    }
  }
  return output;
};
const initializeConfig = userConfig => {
  config = mergeConfigs(defaultConfig, userConfig);
  return config;
};
const getConfig = () => {
  return config;
};
const getSerializableConfig = () => {
  // JSON stringify & parse strips out functions that we don't want to try to send over postMessage
  return JSON.parse(JSON.stringify(getConfig()));
};

const RouteName = {
  AddPayment: 'add-payment',
  AgeVerification: 'age-verification',
  Authenticate: 'authenticate',
  Base: 'base',
  Billing: 'billing',
  Buy: 'buy',
  BuyV2: 'buy-v2',
  BuyV2Interrupt: 'buy-v2-interrupt',
  BuyV2InterruptErrorAlreadySubscribed: 'buy-v2-interrupt-error-already-subscribed',
  BuyV2MismatchStorefrontError: 'buy-v2-error-storefront-mismatch',
  BuyV2InterruptErrorTerminalDialog: 'buy-v2-interrupt-terminal-dialog',
  BuyV2Success: 'buy-v2-success',
  CarrierLinking: 'carrier-linking',
  ChallengePaymentQrCode: 'challenge-payment-qr',
  ContentRestricted: 'content-restricted',
  CreateAccount: 'create-account',
  DeviceLink: 'device-link',
  EditBilling: 'edit-billing',
  EditPayment: 'edit-payment',
  EditShipping: 'edit-shipping',
  Gdpr: 'gdpr',
  InboxMessages: 'inbox-messages',
  KoreaAgeVerification: 'korea-age-verification',
  Logout: 'logout',
  ManagePayments: 'manage-payments',
  ManageSubscriptions: 'manage-subscriptions',
  MusicPlanSelection: 'music-plan-selection',
  MusicStudentUpsell: 'music-student-upsell',
  MusicStudentSubscribe: 'music-student-subscribe',
  SubscriptionEdit: 'subscription-edit',
  ParentalControls: 'parental-controls',
  PaymentRecovery: 'payment-recovery',
  PlanCancel: 'plan-cancel',
  PlanReactivate: 'plan-reactivate',
  PlanSubscribe: 'plan-subscribe',
  PodcastsUpsell: 'contextual-podcasts-upsell',
  Privacy: 'privacy',
  Redeem: 'redeem',
  SegmentReverification: 'segment-reverification',
  SegmentVerified: 'segment-verified',
  Settings: 'settings',
  Subscribe: 'subscribe',
  SubscribeCarrier: 'subscribe-carrier',
  SubscriptionImpactMessaging: 'subscription-impact-messaging',
  SubscriptionPriceIncrease: 'subscription-price-increase',
  SubscriptionPrivacy: 'subscription-privacy',
  SubscriptionCancellationSuccess: 'subscription-cancellation-success',
  SubscriptionSelection: 'subscription-selection',
  Terms: 'terms',
  VerifyPayment: 'verify-payment',
  FetchProxy: 'fetch-proxy'
};
let routeMap = {
  [RouteName.AddPayment]: {
    routeName: RouteName.AddPayment,
    hostedAppId: 'web-app',
    path: '/stackable-payments/add'
  },
  [RouteName.AgeVerification]: {
    routeName: RouteName.AgeVerification,
    hostedAppId: 'web-app',
    path: '/account/verification'
  },
  [RouteName.Authenticate]: {
    routeName: RouteName.Authenticate,
    hostedAppId: 'web-app',
    path: '/authenticate'
  },
  [RouteName.Base]: {
    routeName: RouteName.Base,
    hostedAppId: 'web-app',
    path: '/'
  },
  [RouteName.Buy]: {
    routeName: RouteName.Buy,
    hostedAppId: 'cwa-app',
    path: '/buy'
  },
  [RouteName.BuyV2]: {
    routeName: RouteName.BuyV2,
    hostedAppId: 'web-app',
    path: '/buy'
  },
  [RouteName.BuyV2Interrupt]: {
    routeName: RouteName.BuyV2Interrupt,
    hostedAppId: 'web-app',
    path: '/buy-interrupt'
  },
  [RouteName.BuyV2InterruptErrorAlreadySubscribed]: {
    routeName: RouteName.BuyV2InterruptErrorAlreadySubscribed,
    hostedAppId: 'web-app',
    path: '/buy/error/already-subscribed'
  },
  [RouteName.BuyV2InterruptErrorTerminalDialog]: {
    routeName: RouteName.BuyV2InterruptErrorTerminalDialog,
    hostedAppId: 'web-app',
    path: '/buy/error/dialog'
  },
  [RouteName.BuyV2MismatchStorefrontError]: {
    routeName: RouteName.BuyV2MismatchStorefrontError,
    hostedAppId: 'web-app',
    path: '/buy/error/storefront-mismatch'
  },
  [RouteName.BuyV2Success]: {
    routeName: RouteName.BuyV2Success,
    hostedAppId: 'web-app',
    path: '/buy/success'
  },
  [RouteName.CarrierLinking]: {
    routeName: RouteName.CarrierLinking,
    hostedAppId: 'web-app',
    path: '/account/carrier-linking'
  },
  [RouteName.ChallengePaymentQrCode]: {
    routeName: RouteName.ChallengePaymentQrCode,
    hostedAppId: 'web-app',
    path: '/stackable-payments/challenge-qr'
  },
  [RouteName.ContentRestricted]: {
    routeName: RouteName.ContentRestricted,
    hostedAppId: 'web-app',
    path: '/content-restricted'
  },
  [RouteName.CreateAccount]: {
    routeName: RouteName.CreateAccount,
    hostedAppId: 'web-app',
    path: '/account/create'
  },
  [RouteName.DeviceLink]: {
    routeName: RouteName.DeviceLink,
    hostedAppId: 'web-app',
    path: '/device-link'
  },
  [RouteName.EditBilling]: {
    routeName: RouteName.EditBilling,
    hostedAppId: 'web-app',
    path: '/account/edit-billing'
  },
  [RouteName.EditPayment]: {
    routeName: RouteName.EditPayment,
    hostedAppId: 'web-app',
    path: '/stackable-payments/edit'
  },
  [RouteName.EditShipping]: {
    routeName: RouteName.EditShipping,
    hostedAppId: 'web-app',
    path: '/stackable-payments/shipping/edit'
  },
  [RouteName.FetchProxy]: {
    routeName: RouteName.FetchProxy,
    hostedAppId: 'web-app',
    path: '/fetch-proxy.html'
  },
  [RouteName.Gdpr]: {
    routeName: RouteName.Gdpr,
    hostedAppId: 'web-app',
    path: '/account/privacy'
  },
  [RouteName.InboxMessages]: {
    routeName: RouteName.InboxMessages,
    hostedAppId: 'web-app',
    path: '/inbox-messages'
  },
  [RouteName.KoreaAgeVerification]: {
    routeName: RouteName.KoreaAgeVerification,
    hostedAppId: 'web-app',
    path: '/age-verification/landing'
  },
  [RouteName.Logout]: {
    routeName: RouteName.Logout,
    hostedAppId: 'web-app',
    path: '/logout'
  },
  [RouteName.ManagePayments]: {
    routeName: RouteName.ManagePayments,
    hostedAppId: 'web-app',
    path: '/stackable-payments'
  },
  [RouteName.ManageSubscriptions]: {
    routeName: RouteName.ManageSubscriptions,
    hostedAppId: 'web-app',
    path: '/subscriptions'
  },
  [RouteName.MusicPlanSelection]: {
    routeName: RouteName.MusicPlanSelection,
    hostedAppId: 'web-app',
    path: '/subscribe/plan-selection'
  },
  [RouteName.MusicStudentUpsell]: {
    routeName: RouteName.MusicStudentUpsell,
    hostedAppId: 'web-app',
    path: '/subscribe/student'
  },
  [RouteName.MusicStudentSubscribe]: {
    routeName: RouteName.MusicStudentSubscribe,
    hostedAppId: 'web-app',
    path: '/subscribe/student-subscribe'
  },
  [RouteName.SubscriptionEdit]: {
    routeName: RouteName.SubscriptionEdit,
    hostedAppId: 'web-app',
    path: '/subscription/edit'
  },
  [RouteName.ParentalControls]: {
    routeName: RouteName.ParentalControls,
    hostedAppId: 'web-app',
    path: '/account/settings#parental-controls',
    fragment: '#parental-controls'
  },
  [RouteName.PaymentRecovery]: {
    routeName: RouteName.PaymentRecovery,
    hostedAppId: 'web-app',
    path: '/stackable-payments/payment-recovery'
  },
  [RouteName.PlanCancel]: {
    routeName: RouteName.PlanCancel,
    hostedAppId: 'web-app',
    path: '/plan/cancel'
  },
  [RouteName.PlanReactivate]: {
    routeName: RouteName.PlanReactivate,
    hostedAppId: 'web-app',
    path: '/plan/reactivate'
  },
  [RouteName.PlanSubscribe]: {
    routeName: RouteName.PlanSubscribe,
    hostedAppId: 'web-app',
    path: '/plan/subscribe'
  },
  [RouteName.PodcastsUpsell]: {
    routeName: RouteName.PodcastsUpsell,
    hostedAppId: 'web-app',
    path: '/subscribe/podcasts'
  },
  [RouteName.Privacy]: {
    routeName: 'privacy',
    hostedAppId: 'web-app',
    path: '/account/privacy'
  },
  [RouteName.Redeem]: {
    routeName: RouteName.Redeem,
    hostedAppId: 'web-app',
    path: '/redeem'
  },
  [RouteName.SegmentReverification]: {
    routeName: RouteName.SegmentReverification,
    hostedAppId: 'web-app',
    path: '/subscribe/:segment/reverification'
  },
  [RouteName.SegmentVerified]: {
    routeName: RouteName.SegmentVerified,
    hostedAppId: 'web-app',
    path: '/subscribe/:segment/verified'
  },
  [RouteName.Settings]: {
    routeName: RouteName.Settings,
    hostedAppId: 'web-app',
    path: '/account/settings'
  },
  [RouteName.Billing]: {
    routeName: RouteName.Billing,
    hostedAppId: 'web-app',
    path: '/account/billing'
  },
  [RouteName.Subscribe]: {
    routeName: 'subscribe',
    hostedAppId: 'web-app',
    path: '/subscribe'
  },
  [RouteName.SubscribeCarrier]: {
    routeName: RouteName.SubscribeCarrier,
    hostedAppId: 'web-app',
    path: '/subscribe/carrier'
  },
  [RouteName.SubscriptionPriceIncrease]: {
    routeName: RouteName.SubscriptionPriceIncrease,
    hostedAppId: 'web-app',
    path: '/subscription/price-increase'
  },
  [RouteName.SubscriptionSelection]: {
    routeName: RouteName.SubscriptionSelection,
    hostedAppId: 'web-app',
    path: '/subscription/selection'
  },
  [RouteName.SubscriptionImpactMessaging]: {
    routeName: RouteName.SubscriptionImpactMessaging,
    hostedAppId: 'web-app',
    path: '/subscription/impact-messaging'
  },
  [RouteName.SubscriptionCancellationSuccess]: {
    routeName: RouteName.SubscriptionCancellationSuccess,
    hostedAppId: 'web-app',
    path: '/subscription/cancellation-success'
  },
  [RouteName.SubscriptionPrivacy]: {
    routeName: RouteName.SubscriptionPrivacy,
    hostedAppId: 'web-app',
    path: '/subscription/privacy'
  },
  [RouteName.Terms]: {
    routeName: RouteName.Terms,
    hostedAppId: 'web-app',
    path: '/terms'
  },
  [RouteName.VerifyPayment]: {
    routeName: RouteName.VerifyPayment,
    hostedAppId: 'web-app',
    path: '/verify-payment'
  }
};
const getRouteMap = () => {
  return routeMap;
};
const updateRouteMap = newRouteMap => {
  routeMap = {
    ...routeMap,
    ...newRouteMap
  };
  return routeMap;
};

const constructOrigin = function () {
  let subdomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HostedAppSubdomain.Apps;
  let environment = arguments.length > 1 ? arguments[1] : undefined;
  if (environment) {
    return "https://".concat(environment, ".").concat(subdomain, ".apple.com");
  } else {
    return "https://".concat(subdomain, ".apple.com");
  }
};
const constructBaseUrl = (route, config) => {
  const hostedAppConfig = HostedAppConfig[route.hostedAppId];
  const {
    useRelativeIframeSrc,
    hostedAppMetadata
  } = config;
  const origin = useRelativeIframeSrc ? window.location.origin : constructOrigin(hostedAppMetadata == null ? void 0 : hostedAppMetadata.subdomain, hostedAppMetadata == null ? void 0 : hostedAppMetadata.environment);
  return "".concat(origin).concat(hostedAppConfig.basePath);
};
const resolveRoute = routeName => {
  const routeConfig = getRouteMap()[routeName];
  if (!routeConfig) {
    throw new Error("Could not resolve routeName '".concat(routeName, "'"));
  }
  return routeConfig;
};
const getQueryParams = function (config) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    queryParams,
    isModal
  } = options;
  const {
    theme,
    product,
    devToken,
    productVersion,
    authOptions,
    locale,
    storefront,
    useRelativeIframeSrc,
    hostedAppMetadata
  } = config;
  const iso2or3codeParam = storefront ? storefront.length === 3 ? {
    iso3code: storefront
  } : {
    iso2code: storefront
  } : {};
  return {
    ...(product && {
      product
    }),
    ...(devToken && {
      devToken
    }),
    ...(productVersion && {
      productVersion
    }),
    ...(theme && {
      theme
    }),
    ...((authOptions == null ? void 0 : authOptions.type) && {
      authType: authOptions.type
    }),
    ...((authOptions == null ? void 0 : authOptions.displayType) && {
      authDisplayType: authOptions.displayType
    }),
    ...(locale && {
      locale
    }),
    ...(typeof useRelativeIframeSrc !== 'undefined' && {
      useRelativeIframeSrc: useRelativeIframeSrc.toString()
    }),
    ...iso2or3codeParam,
    ...(isModal ? {
      isModal: 'true',
      modalMode: 'overlay'
    } : {
      isFullscreen: 'true'
    }),
    ...(hostedAppMetadata && {
      hostedAppSubdomain: hostedAppMetadata.subdomain,
      hostedAppEnvironment: hostedAppMetadata.environment
    }),
    ...queryParams
  };
};
const createUrl = (route, options) => {
  var _options$subPath;
  const config = (options == null ? void 0 : options.config) || getConfig();
  const path = [...route.path.split('/'), ...((options == null ? void 0 : (_options$subPath = options.subPath) == null ? void 0 : _options$subPath.split('/')) || [])].filter(Boolean).join('/');
  return new URL("".concat(constructBaseUrl(route, config), "/").concat(path, "?").concat(getQueryParamsStringFromDictionary(getQueryParams(config, {
    queryParams: options == null ? void 0 : options.queryParams,
    isModal: options == null ? void 0 : options.isModal
  }))));
};

const createEventEmitter = () => {
  const listeners = {};
  return {
    addListener: (eventName, listener) => {
      var _listeners$eventName;
      if (!listeners[eventName]) {
        listeners[eventName] = [];
      }
      (_listeners$eventName = listeners[eventName]) == null ? void 0 : _listeners$eventName.push(listener);
    },
    removeListener: (eventName, listenerToRemove) => {
      if (!listeners[eventName]) {
        listeners[eventName] = [];
      }
      listeners[eventName] = listeners[eventName].filter(listener => listener !== listenerToRemove);
    },
    emit: (eventName, sender, data) => {
      const eventListeners = listeners[eventName];
      eventListeners == null ? void 0 : eventListeners.forEach(listener => listener(sender, data));
    }
  };
};

const eventEmitter = createEventEmitter();

// Something unique so as to not clash with a normal `message`
const MESSAGE_EVENT_NAME_KEY = '__cm_event';
const MESSAGE_SENDER_KEY = '__cm_sender';
const MESSAGE_SENDER_KEY_DEPRECATED = '__cm_consuming-product'; // Field kept for backwards compat.
const MESSAGE_DATA_KEY = '__cm_data';
let EventName;
(function (EventName) {
  EventName["AgeVerificationFlowComplete"] = "ageverificationflowcomplete";
  EventName["DidAgeVerify"] = "ageverified";
  EventName["DidGdprAcknowledge"] = "gdpracknowledged";
  EventName["DidSignIn"] = "signedin";
  EventName["DidSignOut"] = "signedout";
  EventName["DidTransition"] = "transitioned";
  EventName["SubscriptionDidChange"] = "subscriptionchanged";
  EventName["RequiresTransition"] = "requirestransition";
  EventName["RequiresContextualUpsell"] = "requirescontextualupselldata";
  EventName["RequiresKoreaAgeVerification"] = "requireskoreaageverificationdata";
  EventName["ContextualUpsell"] = "contextualupselldata";
  EventName["KoreaAgeVerification"] = "koreaageverificationdata";
  EventName["MediaData"] = "mediadata";
  EventName["InitializedHosted"] = "__cm_initialized_hosted";
  EventName["OpenModal"] = "openmodal";
  EventName["CloseModal"] = "closemodal";
  EventName["PushModal"] = "pushmodal";
  EventName["PopModal"] = "popmodal";
  EventName["ModalWasShown"] = "modalwasshown";
  EventName["ModalDidClose"] = "modaldidclose";
  EventName["ModalDidPop"] = "modaldidpop";
  EventName["ReadyToBeShown"] = "readytobeshown";
  EventName["BootWithConfig"] = "bootwithconfig";
  EventName["ShowSportsScoresChange"] = "showsportsscoreschange";
  EventName["AutoPlayNextVideoChange"] = "autoplaynextvideochange";
  EventName["ContentResize"] = "contentresize";
  EventName["UserActivity"] = "useractivity";
  EventName["FetchRequest"] = "fetchrequest";
  EventName["FetchResponse"] = "fetchresponse";
  EventName["AuthRequired"] = "authrequired";
  EventName["AuthFailed"] = "authfailed";
  EventName["RequestStorefrontChange"] = "requestStorefrontChange";
})(EventName || (EventName = {})); // All message payloads must be serializable:
// (https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm)
// rdar://105226807 (Stricter typing on MessageTargetId)

let myTargetId = ''; // can't use `getMyTargetId` due to circular dependencies
let logLevel = 'warning';
const setLoggingTargetId = targetId => {
  myTargetId = targetId;
};
const getLogLevel = () => {
  return logLevel;
};
const initializeLogging = function () {
  let {
    configLogLevel,
    iframeNameLogLevel,
    localStorageLogLevel
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  logLevel = localStorageLogLevel || iframeNameLogLevel || configLogLevel || 'warning';
  return logLevel;
};
const errorAllowedLogs = ['error'];
const warningAllowedLogs = ['error', 'warn'];
const logBase = function (funcName) {
  if (logLevel === 'off' || logLevel === 'error' && !errorAllowedLogs.includes(funcName) || logLevel === 'warning' && !warningAllowedLogs.includes(funcName)) {
    return;
  }
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  const [message, ...restOfArgs] = args;
  if (funcName === 'dir') {
    console.dir(message, ...restOfArgs);
    return;
  }
  (console[funcName] || console.log)("%cCommerceKit v".concat('2.9.0', " %c(").concat(myTargetId, ")%c: ").concat(message), ...restOfArgs, 'background-color: lightgray; color: green', 'background-color: lightgray; color: blue', '');
};
const error = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return logBase('error', ...args);
};
const info = function () {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return logBase('info', ...args);
};
const warn = function () {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  return logBase('warn', ...args);
};
const dir = function () {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }
  return logBase('dir', ...args);
};

const encodePayload = (sender, eventName, data) => ({
  [MESSAGE_SENDER_KEY]: sender,
  [MESSAGE_SENDER_KEY_DEPRECATED]: sender,
  [MESSAGE_EVENT_NAME_KEY]: eventName,
  [MESSAGE_DATA_KEY]: data
});
const decodePayload = message => {
  const sender = message[MESSAGE_SENDER_KEY] || message[MESSAGE_SENDER_KEY_DEPRECATED];
  const eventName = message[MESSAGE_EVENT_NAME_KEY];
  const data = message[MESSAGE_DATA_KEY];
  return {
    eventName,
    data,
    sender
  };
};
const isExpectedOrigin = origin => {
  const url = new URL(origin);
  return url.host.endsWith('.apple.com') && url.protocol === 'https:';
};
const verifyIdentity = event => {
  return isExpectedOrigin(event.origin);
};
const verifyIntendedRecipient = event => {
  // If the message doesn't have the __cm_event field, it clearly isn't intended for our consumption
  const {
    [MESSAGE_EVENT_NAME_KEY]: eventName
  } = event.data;
  return !!eventName;
};
const verifyIntegrity = event => {
  // prettier-ignore
  const {
    [MESSAGE_EVENT_NAME_KEY]: eventName,
    [MESSAGE_SENDER_KEY]: sender,
    [MESSAGE_SENDER_KEY_DEPRECATED]: senderDeprecated
  } = event.data;
  return !!(eventName && (sender || senderDeprecated));
};
const verifyMessage = event => {
  const verifiers = [verifyIdentity, verifyIntendedRecipient, verifyIntegrity];
  for (let i = 0; i < verifiers.length; i++) {
    const verifier = verifiers[i];
    const isVerified = verifier(event);
    if (!isVerified) {
      // Only warn if the message was intended for us
      if (verifier !== verifyIntendedRecipient) {
        warn("Message not verified. Failed on ".concat(verifier.name, "."));
        dir(event);
      }
      return false;
    }
  }
  return true;
};

const logMessage = (eventName, summary, data) => {
  info(summary);
  if (data) {
    info("Data for '".concat(eventName, "' message:"));
    dir(data);
  }
};
const logSend = (targetId, payload) => {
  const {
    eventName,
    data
  } = decodePayload(payload);
  const summary = "Sent message '".concat(eventName, "' to '").concat(targetId, "'");
  logMessage(eventName, summary, data);
};
const logQueue = (targetId, payload) => {
  const {
    eventName,
    data
  } = decodePayload(payload);
  const summary = "Queued message '".concat(eventName, "' to '").concat(targetId, "'");
  logMessage(eventName, summary, data);
};
const logReceive = (eventName, sender, data) => {
  const summary = "Received message '".concat(eventName, "' from '").concat(sender, "'");
  logMessage(eventName, summary, data);
};

const MISSING_DEPENDENCIES = 'MISSING_DEPENDENCIES';

/*
Takes in all dependencies. Filters out non-empty dependencies
and only includes the missing dependencies in the error message
*/
const MissingDependenciesError = class extends Error {
  constructor(dependencies) {
    super();
    const dependenciesListMessage = Object.keys(dependencies).filter(key => !dependencies[key]).join(', ');
    this.name = MISSING_DEPENDENCIES;
    this.message = "Missing dependencies: ".concat(dependenciesListMessage);
  }
};
let ErrorCode;

// https://stashweb.sd.apple.com/projects/AS/repos/apple-media-services/browse/AppleMediaServices/AMSError.h
(function (ErrorCode) {
  ErrorCode[ErrorCode["Auth"] = 401] = "Auth";
  ErrorCode[ErrorCode["ServerUnknown"] = 5002] = "ServerUnknown";
})(ErrorCode || (ErrorCode = {}));
let AMSErrorCode;
(function (AMSErrorCode) {
  AMSErrorCode[AMSErrorCode["AMSErrorCodeCancelled"] = 6] = "AMSErrorCodeCancelled";
})(AMSErrorCode || (AMSErrorCode = {}));
let ErrorType;
(function (ErrorType) {
  ErrorType["Auth"] = "Authentication";
  ErrorType["TermsAuth"] = "MZFinance.TermsCheckLoginRequired";
  ErrorType["MediaLinkInvalidSession"] = "MEDIA_LINK_INVALID_SESSION";
})(ErrorType || (ErrorType = {}));
let CommerceServerErrorMessageKey;
(function (CommerceServerErrorMessageKey) {
  CommerceServerErrorMessageKey["NoAuthorization"] = "MZCommerce.NoAuthorization";
  CommerceServerErrorMessageKey["AlreadyClaimed"] = "MZCommerce.HardBundleAlreadyClaimed";
})(CommerceServerErrorMessageKey || (CommerceServerErrorMessageKey = {}));

let messageTargets = {};
const dataAttributeNameTargetId = 'data-ck-target-id';
const initializeTargeting = () => {
  // Save the target ID for logging purposes.
  setLoggingTargetId(getMyTargetId());
  if (isInIframe()) {
    addMessageTarget(getParentOrigin(), {
      targetWindow: window.parent,
      targetId: 'parent',
      isReady: true
    });
  }
  addMessageTarget(window.location.origin, {
    targetId: 'self',
    targetWindow: window,
    isReady: true
  });
};
const encodeIframeName = (parentOrigin, targetId) => {
  const params = new URLSearchParams({
    parentOrigin,
    targetId,
    parentCommerceKitVersion: '2.9.0' ,
    logLevel: getLogLevel()
  });
  return params.toString();
};
const decodeIframeName = iframeName => {
  const params = new URLSearchParams(iframeName);
  return {
    parentOrigin: params.get('parentOrigin') || '',
    targetId: params.get('targetId') || '',
    parentCommerceKitVersion: params.get('parentCommerceKitVersion') || '',
    logLevel: params.get('logLevel') || ''
  };
};
const createTargetId = function (parentTargetId, initialRouteName) {
  let collisionAttemptNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const targetIdSuffix = collisionAttemptNumber > 0 ? "-".concat(collisionAttemptNumber) : '';
  const proposedTargetId = "".concat(parentTargetId ? "".concat(parentTargetId, "->") : '').concat(initialRouteName).concat(targetIdSuffix);

  // Handle collisions
  if (messageTargets[proposedTargetId]) {
    return createTargetId(parentTargetId, initialRouteName, collisionAttemptNumber + 1);
  }
  return proposedTargetId;
};
const getMyTargetId = () => {
  // Parent will tell us what our target ID is. If it's not set, we can assume we're the parent ('root')
  if (window.name && window.name.includes('targetId')) {
    const {
      targetId
    } = decodeIframeName(window.name);
    return targetId;
  }
  return 'root';
};
const getParentOrigin = () => {
  if (window.name && window.name.includes('parentOrigin')) {
    const {
      parentOrigin
    } = decodeIframeName(window.name);
    return parentOrigin;
  }
  return window.location.origin;
};
const getMessageTarget = targetId => messageTargets[targetId];
const getMessageTargets = () => messageTargets;
const readyMessageTarget = targetId => {
  if (messageTargets[targetId]) {
    messageTargets[targetId].isReady = true;
    info("Message target '".concat(targetId, "' now ready"));
  }
};
const addMessageTarget = function (targetOrigin) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isReady: false
  };
  const {
    targetWindow,
    targetId,
    isReady,
    initialRouteName
  } = options;
  if (!targetId && !initialRouteName) {
    throw new MissingDependenciesError({
      targetId,
      initialRouteName
    });
  }
  const messageTargetId = targetId || createTargetId(getMyTargetId(), initialRouteName || '');
  messageTargets[messageTargetId] = {
    id: messageTargetId,
    targetOrigin,
    targetWindow,
    isReady,
    queue: []
  };
  info("Added message target with ID: '".concat(messageTargetId, "' and origin: '").concat(targetOrigin, "'"));
  return messageTargetId;
};
const setTargetWindowForMessageTarget = (targetId, targetWindow) => {
  messageTargets[targetId].targetWindow = targetWindow || undefined;
};
const removeMessageTarget = targetId => {
  if (messageTargets[targetId]) {
    delete messageTargets[targetId];
  }
  info("Removed message target with ID: '".concat(targetId, "'"));
};
const getMessageTargetIdFromIframe = iframeEl => {
  const targetId = iframeEl.getAttribute(dataAttributeNameTargetId);
  if (!targetId) {
    throw new Error('Unable to retrieve target ID for iframe');
  }
  return targetId;
};

const sendWithPayload = (targetId, payload) => {
  const target = getMessageTarget(targetId);
  if (!target) {
    warn('Unknown message target ID. Discarding message.');
    return;
  }
  const {
    targetWindow,
    targetOrigin,
    isReady,
    queue
  } = target;
  if (!isExpectedOrigin(targetOrigin)) {
    error("Failed to send message: Unexpected origin '".concat(targetOrigin, "'"));
    return;
  }
  if (!isReady || !targetWindow) {
    queue.push(payload);
    logQueue(targetId, payload);
  } else {
    targetWindow.postMessage(payload, targetOrigin);
    logSend(targetId, payload);
  }
};
const send = (targetId, eventName, data) => {
  const payload = encodePayload(getMyTargetId(), eventName, data);
  sendWithPayload(targetId, payload);
};
const sendQueuedMessages = targetId => {
  const target = getMessageTarget(targetId);
  if (!target) {
    warn('Unknown message target ID. Unable to flush queue.');
    return;
  }

  // We will try to flush the queue after receiving an InitializedHosted event
  // as well as on the iframe 'load' event. This is because we can't guarantee the ordering
  // of these two events, but both must occur before sending messages.

  if (!target.isReady) {
    info("Attempted to flush message queue before target ".concat(targetId, " was marked as ready."));
    return;
  }
  if (!target.targetWindow) {
    info("Attempted to flush message queue before target ".concat(targetId, " iframe was loaded."));
    return;
  }
  info("Flushing message queue for targetId: ".concat(targetId));
  target.queue.forEach(payload => {
    sendWithPayload(targetId, payload);
  });
  target.queue = [];
};
const sendToAllTargets = (eventName, data) => {
  const messageTargets = getMessageTargets();
  Object.keys(messageTargets).forEach(targetId => {
    send(targetId, eventName, data);
  });
};
const sendToAllChildTargets = (eventName, data) => {
  const messageTargets = getMessageTargets();
  Object.keys(messageTargets).filter(targetId => targetId !== 'self' && targetId !== 'parent').forEach(targetId => {
    send(targetId, eventName, data);
  });
};

let bootConfig;
const targetToCleanupFuncMap = new Map();
const createIframeWithRouteConfig = (routeConfig, userProvidedOptions) => {
  const {
    queryParams,
    onReadyToBeShown,
    shouldAutoResize,
    data,
    isModal,
    subPath
  } = userProvidedOptions || {};
  const iframeEl = document.createElement('iframe');
  const {
    useRelativeIframeSrc
  } = getConfig();
  const url = createUrl(routeConfig, {
    subPath,
    queryParams,
    isModal
  });
  const messageTargetId = addMessageTarget(url.origin, {
    initialRouteName: routeConfig.routeName,
    isReady: false
  });
  const onIframeLoad = () => {
    info("iframe for target ".concat(messageTargetId, " loaded"));
    setTargetWindowForMessageTarget(messageTargetId, iframeEl.contentWindow);
    send(messageTargetId, EventName.BootWithConfig, {
      data,
      parentConfig: getSerializableConfig()
    });
    sendQueuedMessages(messageTargetId);
  };
  iframeEl.addEventListener('load', onIframeLoad);
  if (useRelativeIframeSrc) {
    iframeEl.src = "".concat(url.pathname).concat(url.search);
  } else {
    iframeEl.src = url.href;
  }

  // Tag the iframe with the parent's origin and its target ID as the parent knows it
  // so the child can initialize with these properties using window.name
  iframeEl.name = encodeIframeName(window.location.origin, messageTargetId);
  iframeEl.allow = "publickey-credentials-get ".concat(url.origin);

  // Mark the iframe as ck-managed for easier lookup
  iframeEl.setAttribute('data-is-ck-managed', '');
  iframeEl.setAttribute(dataAttributeNameTargetId, messageTargetId);
  iframeEl.setAttribute('role', 'presentation');
  iframeEl.style.border = '0';
  iframeEl.style.width = '100%';
  iframeEl.style.height = '100%';
  const readyToBeShownHandler = function (sender, data) {
    if (sender === messageTargetId) {
      onReadyToBeShown == null ? void 0 : onReadyToBeShown();
      if (data) {
        const {
          pageTitle
        } = data;
        iframeEl.title = pageTitle;
      }
    }
  };
  eventEmitter.addListener(EventName.ReadyToBeShown, readyToBeShownHandler);
  const contentResizeHandler = (sender, _ref) => {
    let {
      height
    } = _ref;
    if (sender === messageTargetId || sender === 'root') {
      iframeEl.style.height = "".concat(height, "px");
    }
  };
  if (shouldAutoResize) {
    eventEmitter.addListener(EventName.ContentResize, contentResizeHandler);
  }
  targetToCleanupFuncMap.set(messageTargetId, () => {
    eventEmitter.removeListener(EventName.ReadyToBeShown, readyToBeShownHandler);
    if (shouldAutoResize) {
      eventEmitter.removeListener(EventName.ContentResize, contentResizeHandler);
    }
    removeMessageTarget(messageTargetId);
    iframeEl.removeEventListener('load', onIframeLoad);
    iframeEl.remove();
  });
  return {
    messageTargetId,
    iframeEl,
    ...(undefined)
  };
};
const createIframe = (routeName, userProvidedOptions) => {
  return createIframeWithRouteConfig(resolveRoute(routeName), userProvidedOptions);
};
const showIframe = (iframeEl, messageTargetId) => {
  iframeEl.style.display = 'inherit';
  send(messageTargetId, EventName.ModalWasShown);
};
const hideIframe = iframeEl => {
  iframeEl.style.display = 'none';
};
const destroyIframe = target => {
  let targetId;
  if (target instanceof HTMLIFrameElement) {
    targetId = getMessageTargetIdFromIframe(target);
  } else {
    targetId = target;
  }
  const cleanupFunc = targetToCleanupFuncMap.get(targetId);
  if (!cleanupFunc) {
    throw new Error("Failed to destroy iframe with ID '".concat(targetId, "'. Cleanup function not found."));
  }
  cleanupFunc();
  targetToCleanupFuncMap.delete(targetId);
  info("Destroyed iframe with ID '".concat(targetId, "'"));
};
let modalStack = [];
const getModalOptions = overrides => {
  const {
    modalOptions
  } = getConfig();

  // Prefer local overrides over global config
  return {
    ...modalOptions,
    ...overrides
  };
};
const bootstrapModalIframe = (routeConfig, options) => {
  const {
    containerSelector,
    onModalReadyToBeShown,
    onModalWasShown,
    onModalRequested,
    queryParams,
    data
  } = options;
  const container = document.querySelector(containerSelector || 'body');
  if (!container) {
    throw new Error("Modal container element not found with selector '".concat(containerSelector, "'"));
  }
  onModalRequested == null ? void 0 : onModalRequested();
  const {
    iframeEl,
    messageTargetId
  } = createIframeWithRouteConfig(routeConfig, {
    queryParams,
    subPath: options.path,
    onReadyToBeShown: () => {
      onModalReadyToBeShown == null ? void 0 : onModalReadyToBeShown();
      showIframe(iframeEl, messageTargetId);
      onModalWasShown == null ? void 0 : onModalWasShown();
    },
    data,
    isModal: true
  });
  hideIframe(iframeEl); // Hide until ReadyToBeShown to avoid showing a white screen
  iframeEl.style.position = 'fixed';
  iframeEl.style.top = '0';
  iframeEl.style.right = '0';
  iframeEl.style.bottom = '0';
  iframeEl.style.left = '0';
  return {
    iframeEl,
    messageTargetId,
    container
  };
};
const createModalDidClosePromise = onModalClose => {
  return new Promise(resolve => {
    const handler = (sender, returnData) => {
      if (modalStack.length === 0) {
        onModalClose == null ? void 0 : onModalClose();
      }
      eventEmitter.removeListener(EventName.ModalDidPop, handler);
      eventEmitter.removeListener(EventName.ModalDidClose, handler);

      // Forward to all known children since the parent may not be aware of child-owned iframes
      sendToAllChildTargets(EventName.ModalDidClose, returnData);
      resolve(returnData);
    };

    // Listen for both in case we're popping the last modal on the stack
    eventEmitter.addListener(EventName.ModalDidPop, handler);
    eventEmitter.addListener(EventName.ModalDidClose, handler);
  });
};
const shouldRelayModalMessage = () => {
  return getMyTargetId() !== 'root';
};
const openModalWithRouteConfig = (routeName, routeConfig, options) => {
  const modalOptions = getModalOptions(options);
  const {
    onModalClose,
    queryParams,
    path,
    data
  } = modalOptions;
  if (shouldRelayModalMessage()) {
    // Relay the message up to the parent
    send('parent', EventName.OpenModal, {
      routeName,
      routeConfig: {
        ...routeConfig,
        expectsModalLayout: true
      },
      path,
      queryParams,
      data
    });
    return createModalDidClosePromise(onModalClose);
  }
  const {
    container,
    iframeEl,
    messageTargetId
  } = bootstrapModalIframe(routeConfig, modalOptions);
  modalStack = [{
    iframeEl,
    messageTargetId
  }];
  container.replaceChildren(iframeEl);
  return createModalDidClosePromise(onModalClose);
};
const openModal = (routeName, options) => {
  return openModalWithRouteConfig(routeName, resolveRoute(routeName), options);
};
const closeModal = returnData => {
  if (shouldRelayModalMessage()) {
    // Relay the message up to the parent
    send('parent', EventName.CloseModal, returnData);
    return;
  }

  // Close all modals
  modalStack.forEach(modalInstance => {
    destroyIframe(modalInstance.messageTargetId);
  });
  modalStack = [];

  // Notify all remaining targets that the modal closed so they
  // can respond appropriately with the returnData (eg. refresh)
  sendToAllTargets(EventName.ModalDidClose, returnData);
};
const pushModalWithRouteConfig = (routeName, routeConfig, options) => {
  const modalOptions = getModalOptions(options);
  const {
    onModalClose,
    queryParams,
    path,
    data
  } = modalOptions;
  if (shouldRelayModalMessage()) {
    // Relay the message up to the parent
    send('parent', EventName.PushModal, {
      routeName,
      routeConfig: {
        ...routeConfig,
        expectsModalLayout: true
      },
      path,
      queryParams,
      data
    });
    return createModalDidClosePromise(onModalClose);
  }
  const {
    container,
    iframeEl,
    messageTargetId
  } = bootstrapModalIframe(routeConfig, modalOptions);
  if (modalStack.length > 0) {
    const topModal = modalStack[modalStack.length - 1];
    hideIframe(topModal.iframeEl);
  }
  modalStack.push({
    iframeEl,
    messageTargetId
  });
  container.appendChild(iframeEl);
  return createModalDidClosePromise(onModalClose);
};
const pushModal = (routeName, options) => {
  return pushModalWithRouteConfig(routeName, resolveRoute(routeName), options);
};
const popModal = returnData => {
  if (shouldRelayModalMessage()) {
    // Relay the message up to the parent
    send('parent', EventName.PopModal, returnData);
    return;
  }
  const modalToClose = modalStack.pop();
  if (!modalToClose) {
    return;
  }
  if (modalStack.length <= 0) {
    destroyIframe(modalToClose.messageTargetId);
    // Notify all remaining targets that the modal closed so they
    // can respond appropriately with the returnData (eg. refresh)
    sendToAllTargets(EventName.ModalDidClose, returnData);
    return;
  }
  const modalToShow = modalStack[modalStack.length - 1];

  // Notify next modal that the modal on top of it popped
  send(modalToShow.messageTargetId, EventName.ModalDidPop, returnData);
  eventEmitter.addListener(EventName.ReadyToBeShown, function readyToBeShownHandler(sender) {
    // Wait to remove & show until the next modal is ready in order to have a more seamless transition
    if (sender === modalToShow.messageTargetId) {
      destroyIframe(modalToClose.messageTargetId);
      showIframe(modalToShow.iframeEl, modalToShow.messageTargetId);
      eventEmitter.removeListener(EventName.ReadyToBeShown, readyToBeShownHandler);
    }
  });
};
const getBootConfig = () => {
  if (bootConfig) {
    return Promise.resolve(bootConfig);
  }
  return new Promise(resolve => {
    info('Waiting for boot config');
    const timeoutId = setTimeout(() => {
      warn('Still waiting for boot config. Page may fail to load.');
    }, 5000);
    eventEmitter.addListener(EventName.BootWithConfig, function bootHandler(sender, data) {
      eventEmitter.removeListener(EventName.BootWithConfig, bootHandler);
      info('Boot config received');
      clearTimeout(timeoutId);
      resolve(data);
    });
  });
};
const setBootConfig = config => {
  bootConfig = config;
};
const addResizeObserver = () => {
  const resizeObserver = new ResizeObserver(throttle(entries => {
    if (entries.length === 0) {
      return;
    }
    const {
      borderBoxSize
    } = entries[0];
    if (!(borderBoxSize != null && borderBoxSize.length)) {
      return;
    }
    const body = borderBoxSize[0];
    const bodyHeight = body.blockSize;
    const bodyWidth = body.inlineSize;
    if (bodyHeight > 0) {
      send('parent', EventName.ContentResize, {
        width: bodyWidth,
        height: bodyHeight
      });
    }
  }, 100));
  resizeObserver.observe(document.body);
};
const startDetectingUserActivityIfEnabled = async () => {
  const bootConfig = await getBootConfig();
  if (bootConfig != null && bootConfig.parentConfig.shouldDetectUserActivity) {
    var _userActivityOptions$;
    const {
      userActivityOptions
    } = bootConfig.parentConfig;
    const eventHandler = throttle(() => {
      send('parent', EventName.UserActivity);
    }, typeof (userActivityOptions == null ? void 0 : userActivityOptions.detectionIntervalInMs) !== 'undefined' ? userActivityOptions.detectionIntervalInMs : 1000);
    userActivityOptions == null ? void 0 : (_userActivityOptions$ = userActivityOptions.eventsToDetect) == null ? void 0 : _userActivityOptions$.forEach(event => {
      document.addEventListener(event, eventHandler);
    });
  }
};

let proxyIframeTargetId;
const createFetchResponseFromMessagePayload = messagePayload => {
  return {
    httpStatus: messagePayload.httpStatus,
    body: messagePayload.body,
    error: messagePayload.error
  };
};
const handlers = {};
const handleFetchResponse = (sender, data) => {
  const {
    httpStatus,
    error,
    requestId
  } = data;
  if (!handlers[requestId]) {
    return;
  }

  // If we do not have an httpStatus and there is an error, that means the request failed for some
  // reason (like a network fault), and we should reject.
  //
  // Otherwise, we can assume that the request was successful (regardless of what the httpStatus
  // actually is) and we should resolve. This matches the browser's fetch behavior.
  //
  // Note that it is typical to have a successful response without an httpStatus due to
  // makeHttpRequest's current implementation.
  if (!httpStatus && error) {
    handlers[requestId].reject(createFetchResponseFromMessagePayload(data));
  } else {
    handlers[requestId].resolve(createFetchResponseFromMessagePayload(data));
  }
  delete handlers[requestId];
};
const createRequestId = function (bagKey) {
  let collisionAttemptNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const proposedRequestId = collisionAttemptNumber > 0 ? "".concat(bagKey, "-").concat(collisionAttemptNumber) : "".concat(bagKey);
  if (!handlers[proposedRequestId]) {
    return proposedRequestId;
  } else {
    return createRequestId(bagKey, collisionAttemptNumber + 1);
  }
};
const fetch = async function (bagKey) {
  let requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let fetchOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise((resolve, reject) => {
    if (!proxyIframeTargetId) {
      warn('Fetch was called, but proxy iframe was not rendered. Ensure fetchOptions.shouldEnableFetchProxy is set to true.');
    }
    const requestId = createRequestId(bagKey);
    handlers[requestId] = {
      resolve,
      reject
    };
    const {
      devToken
    } = getConfig();
    if (fetchOptions.shouldIncludeAuthorizationHeader && devToken) {
      requestOptions.headers = {
        ...requestOptions.headers,
        Authorization: "Bearer ".concat(devToken)
      };
    }
    send(proxyIframeTargetId, EventName.FetchRequest, {
      bagKey,
      requestId,
      requestOptions
    });
  });
};
const renderFetchProxyIframe = () => {
  var _document$querySelect;
  const {
    messageTargetId,
    iframeEl
  } = createIframe(RouteName.FetchProxy);
  iframeEl.style.width = '0';
  iframeEl.style.height = '0';
  iframeEl.style.display = 'none';
  const {
    fetchOptions
  } = getConfig();
  (_document$querySelect = document.querySelector((fetchOptions == null ? void 0 : fetchOptions.proxyContainerSelector) || 'body')) == null ? void 0 : _document$querySelect.appendChild(iframeEl);
  proxyIframeTargetId = messageTargetId;
};

const buy = (buyParams, buyOptions) => {
  const buyParamsObj = typeof buyParams === 'string' ? getQueryParamsObj(buyParams) : buyParams;
  return openModal(RouteName.BuyV2, {
    data: {
      ...(buyOptions || {}),
      buyParams: buyParamsObj
    }
  });
};
const authenticate = async function () {
  let {
    attemptSilentAuth,
    queryParams
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    attemptSilentAuth: false
  };
  const {
    result
  } = await pushModal(RouteName.Authenticate, {
    queryParams: {
      ...queryParams,
      ...(attemptSilentAuth && {
        attemptSilentAuth
      }),
      shouldPopModal: true
    }
  });
  return result ? {
    result
  } : undefined;
};
const logout = () => {
  return openModal(RouteName.Logout);
};
const openPriceIncreaseAgreement = (subscriptionId, acknowledgeData) => {
  return openModal(RouteName.SubscriptionPriceIncrease, {
    data: {
      acknowledgeData
    },
    queryParams: {
      subscriptionId
    }
  });
};
const openInboxMessages = inboxMessages => {
  return openModal(RouteName.InboxMessages, {
    data: {
      inboxMessages
    }
  });
};
const getInboxMessages = async filters => {
  return fetch(BagKey.InboxMessages, {
    queryParams: filters ? {
      subscriptionType: filters.subscriptionType,
      messageType: filters.messageType
    } : undefined
  }, {
    shouldIncludeAuthorizationHeader: true
  });
};
const getPriceIncreaseMessages = async subscriptionType => {
  return getInboxMessages({
    subscriptionType,
    messageType: 'PRICE_INCREASE'
  });
};

var api = {
  // Embedding
  createIframe,
  destroyIframe,
  openModal,
  closeModal,
  pushModal,
  popModal,
  getBootConfig,
  // Messaging
  send,
  getMessageTarget,
  getMessageTargets,
  // Events
  eventEmitter,
  fetch,
  // Convenience calls
  buy,
  authenticate,
  logout,
  openPriceIncreaseAgreement,
  getInboxMessages,
  openInboxMessages,
  getPriceIncreaseMessages,
  version: '2.9.0'
};

let isListening = false;
const handleInitializedHosted = sender => {
  readyMessageTarget(sender);
  sendQueuedMessages(sender);
};
const handleOpenModal = (sender, data) => {
  const {
    routeName,
    routeConfig,
    queryParams,
    data: openModalData
  } = data;

  // routeConfig preferred, but routeName supported for backwards compat
  if (routeConfig) {
    openModalWithRouteConfig(routeConfig.routeName, routeConfig, {
      queryParams,
      data: openModalData
    });
  } else if (routeName) {
    openModal(routeName, {
      queryParams,
      data: openModalData
    });
  }
};
const handlePushModal = (sender, data) => {
  const {
    routeName,
    routeConfig,
    queryParams,
    path,
    data: openModalData
  } = data;

  // routeConfig preferred, but routeName supported for backwards compat
  if (routeConfig) {
    pushModalWithRouteConfig(routeConfig.routeName, routeConfig, {
      queryParams,
      path,
      data: openModalData
    });
  } else if (routeName) {
    pushModal(routeName, {
      queryParams,
      path,
      data: openModalData
    });
  }
};
const handleCloseModal = (sender, data) => {
  closeModal(data);
};
const handlePopModal = (sender, data) => {
  popModal(data);
};
const handleBootWithConfig = (sender, data) => {
  setBootConfig(data);
};
const handleUserActivity = (sender, data) => {
  // Relay UserActivity event up the hierarchy so all descendents are aware of activity in nested frames
  if (getMyTargetId() !== 'root') {
    send('parent', EventName.UserActivity, data);
  }
};
const addEventListeners = () => {
  eventEmitter.addListener(EventName.InitializedHosted, handleInitializedHosted);
  eventEmitter.addListener(EventName.OpenModal, handleOpenModal);
  eventEmitter.addListener(EventName.CloseModal, handleCloseModal);
  eventEmitter.addListener(EventName.BootWithConfig, handleBootWithConfig);
  eventEmitter.addListener(EventName.PushModal, handlePushModal);
  eventEmitter.addListener(EventName.PopModal, handlePopModal);
  eventEmitter.addListener(EventName.UserActivity, handleUserActivity);
  eventEmitter.addListener(EventName.FetchResponse, handleFetchResponse);
};
const handleMessage = event => {
  if (!verifyMessage(event)) {
    return;
  }
  const {
    eventName,
    sender,
    data
  } = decodePayload(event.data);
  logReceive(eventName, sender, data);
  eventEmitter.emit(eventName, sender, data);
};
const listen = () => {
  if (isListening) {
    return;
  }
  window.addEventListener('message', handleMessage);
  addEventListeners();
  isListening = true;
  info("Started listening");
};
const finishInitialization = () => {
  send('parent', EventName.InitializedHosted);
};

const setupCommerceKit = config => {
  var _mergedConfig$fetchOp;
  const mergedConfig = initializeConfig(config);
  initializeLogging({
    configLogLevel: mergedConfig.logLevel,
    iframeNameLogLevel: decodeIframeName(window.name).logLevel,
    localStorageLogLevel: localStorage.getItem('ckLogLevel')
  });
  if (mergedConfig.routeMap) {
    updateRouteMap(mergedConfig.routeMap);
  }
  initializeTargeting();
  listen();
  if (isInIframe()) {
    addResizeObserver();
    startDetectingUserActivityIfEnabled();
    mergedConfig.onBeforeBoot == null ? void 0 : mergedConfig.onBeforeBoot(api);
    finishInitialization();
  } else if ((_mergedConfig$fetchOp = mergedConfig.fetchOptions) != null && _mergedConfig$fetchOp.shouldEnableFetchProxy) {
    renderFetchProxyIframe();
  }
  return api;
};

// Helper to return the API instance to aid the consuming app in not keep track
const getCommerceKit = () => api;

export { AuthDisplayType, AuthType, BagKey, EventName, HostedAppEnvironment, HostedAppSubdomain, RouteName, Theme, getCommerceKit, getRouteMap, setupCommerceKit };
//# sourceMappingURL=commercekit.mjs.map
